<template>
  <PopupWrapper :title="$t('select_game_to_play')" :ref="(el: any) => popup = el" class="popup-float" :hide-close-btn="false">
    <loader-content :ref="(el: any) => {loader = el; onShown()}">
      <div class="game-list ">
        <div v-if="store.getters.favoriteGames.length !== 0">
          <div class="mt-2">
            <h2 class="text-capitalize-first">{{$t('favorite_games')}}</h2>
          </div>

          <div class="games-wrapper ms-0 me-0">
            <game-icon :hide-fav="true" :beforePlay="beforePlay" v-for="(game, index) in store.getters.favoriteGames" :key="game.id" :game="game"></game-icon>
          </div>
        </div>
        <div>
          <div class="mt-2">
            <h2 class="text-capitalize-first">{{$t('games')}}</h2>
          </div>

          <div class="games-wrapper ms-0 me-0">
            <game-icon :hide-fav="true" :beforePlay="beforePlay" v-for="(game, index) in state.games.items" :key="game.id" :game="game"></game-icon>
          </div>
        </div>

      </div>
    </loader-content>
  </PopupWrapper>
</template>
<script setup lang="ts">
import PopupWrapper from "@/components/PopupWrapper.vue";
import {reactive} from "@vue/reactivity";
import {ref} from "vue";
import LoaderContent from "@/components/LoaderContent.vue";
import {useStore} from "vuex";
import GameIcon from "@/components/games/GameIcon.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import GameDTO from "@/models/GameDTO";
import {api} from "@/service/APIClient";

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore();
const state = reactive({
  isShown: false,
  games: {
    limit: 100,
    offset: 0,
    totalCount: 0,
    items: []
  } as PaginatedResponseDTO<GameDTO>,
})

const show = () => {
  state.isShown = false;
  popup.value?.show()
}

const onShown = () => {
  if (state.isShown) {
    return
  }

  state.isShown = true;
  loader.value?.load(async () => {
    [state.games] = await Promise.all([
      api.call.games.list(state.games),
    ])
  });
}

const hide = () => {
  popup.value?.hide()
}

const beforePlay = async () => {
  popup.value?.hide()
}

defineExpose({ show, hide })
const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)

</script>